import { addLastPrefixEN } from '../transforms/addLastPrefix';
import { formatOrdinalEN } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var enZA = overrideBaseLocale('en-ZA', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalEN],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixEN],
    },
});
//# sourceMappingURL=en-ZA.js.map